import { ReactElement } from 'react';
import { observer, inject } from 'mobx-react';

import Spinner, {
  IProps as ISpinnerProps,
  DEFAULT_SPINNER_COLOR
} from '../Spinner';

import { ISpinnerOverlay } from '../../models/spinnerOverlay';

import './styles.scss';

interface IInjectedProps extends ISpinnerProps {
  spinnerOverlayModel: ISpinnerOverlay;
}

const SpinnerOverlay = inject('spinnerOverlayModel')(
  observer(
    ({
      className = '',
      color = DEFAULT_SPINNER_COLOR,
      ...props
    }: ISpinnerProps): ReactElement | null => {
      const injectedProps = props as IInjectedProps;

      const onPress = (e: React.MouseEvent) => e.preventDefault();

      return injectedProps.spinnerOverlayModel.enable ? (
        <div className={`spinner-overlay ${className}`} onClick={onPress}>
          <Spinner className="spinner-overlay-spinner" color={color} />
        </div>
      ) : null;
    }
  )
);

export default SpinnerOverlay;
